/* eslint-disable */
import fetchConTimeout, { esTimeout } from "./fetchConTimeout";

const {
  VUE_APP_HOB: urlServicio,
  VUE_APP_HOB_USUARIO: usuarioServicio,
  VUE_APP_HOB_CONTRASENA: contrasenaServicio,
} = process.env;

class WebServiceHub {
  constructor() {
    this._usuario = usuarioServicio;
    this._contrasena = contrasenaServicio;
    this._clientId = 1021;
  }

  get token() {
    const datosAutenticacion = {
      Username: this._usuario,
      Password: this._contrasena,
      ClientId: this._clientId,
    };

    const body = JSON.stringify({
      ...datosAutenticacion,
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body,
    };

    return fetchConTimeout(`${urlServicio}gettoken`, requestOptions)
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => {
        if (esTimeout(error)) throw error;
        console.log("error", error);
      });
  }

  async consultarVehiculo(placa) {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${await this.token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      const response = await fetchConTimeout(
        `${urlServicio}vehiculo/${placa}`,
        requestOptions
      );
      return await response.json();
    } catch (error) {
      if (esTimeout(error)) return { timeout: true };
      console.error(error);
    }
  }
}

export default WebServiceHub;
